
import React, { useState } from "react";

import "./BookSessionForm.css";
import { section } from "framer-motion/client";
import { PRICING } from "../constants"

const BookSessionForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    slotInterested: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Backend API call to save data in DynamoDB and send email
    try {
      const response = await fetch("https://your-api-endpoint.amazonaws.com/saveLead", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        alert("Your session request has been submitted!");
        setFormData({ name: "", phone: "", email: "", slot: "", about: "" });
      } else {
        alert("Failed to submit the form. Please try again.");
      }
    } catch (error) {
      alert("An error occurred: " + error.message);
    }
  };

  
  const minDate = new Date().toISOString().split("T")[0]; // Current date
  const maxDate = new Date();
  maxDate.setDate(maxDate.getDate() + 70); // 10 weeks from now
  const maxDateString = maxDate.toISOString().split("T")[0];

  return (
    // <form onSubmit={handleSubmit} className="book-session-form">
    //   <div>
    //     <label htmlFor="name">Name:</label>
    //     <input
    //       type="text"
    //       id="name"
    //       name="name"
    //       value={formData.name}
    //       onChange={handleChange}
    //       required
    //     />
    //   </div>
    //   <div>
    //     <label htmlFor="email">Email:</label>
    //     <input
    //       type="email"
    //       id="email"
    //       name="email"
    //       value={formData.email}
    //       onChange={handleChange}
    //       required
    //     />
    //   </div>
    //   <div>
    //     <label htmlFor="phone">Phone:</label>
    //     <input
    //       type="tel"
    //       id="phone"
    //       name="phone"
    //       value={formData.phone}
    //       onChange={handleChange}
    //       required
    //     />
    //   </div>
    //   <div>
    //     <label htmlFor="slotInterested">Date Interested:</label>
    //     <input
    //       type="date"
    //       id="slotInterested"
    //       name="slotInterested"
    //       value={formData.slotInterested}
    //       onChange={handleChange}
    //       min={minDate}
    //       max={maxDateString}
    //       required
    //     />
    //   </div>
    //   <div>
    //     <label htmlFor="message">Message:</label>
    //     <textarea
    //       id="message"
    //       name="message"
    //       value={formData.message}
    //       onChange={handleChange}
    //     ></textarea>
    //   </div>
    //   <button type="submit">Submit</button>
    // </form>
  // <section id="book-session-form" className="book-session-form">
  //   <iframe 
  //     aria-label="Your perfect moment is just a click away." 
  //     frameborder="0" 
  //     style={{ height: "1150px", width: "99%", border: "none" }}
  //     src="https://forms.zohopublic.in/littlesmilesphotography1/form/Bookasessionwithus/formperma/umdDOLLuP3DLUKDoebQLc6nOw1d8ujJkf_TTmU4srGI">
  //   </iframe>
  // </section>
  <section id="book-session-form" className="book-session-form" style={{ padding: "20px", backgroundColor: "#f9f9f9", borderRadius: "10px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)" }}>
  <div>
    <h2>Welcome to Little Smiles Photography!</h2>
    <p>
      We specialize in capturing the magic of childhood and the beauty of motherhood with stunning, professional photos.<br/><br/>Starting at just ₹{PRICING.INDIA.DEFAULT}, our affordable packages ensure you get unforgettable memories without breaking the bank. <br/><br/>Using state-of-the-art equipment like the Canon EOS R6 II and premium RF lenses, we create dreamy, smooth images that you’ll treasure forever.
    </p>
    <p style={{ fontSize: "16px", fontWeight: "bold" }}>
      Let’s turn your precious moments into timeless art!
    </p>
  </div>
  <iframe 
    aria-label="Your perfect moment is just a click away." 
    frameBorder="0" 
    style={{ height: "1150px", width: "100%", border: "none", borderRadius: "10px" }}
    src="https://forms.zohopublic.in/littlesmilesphotography1/form/Bookasessionwithus/formperma/umdDOLLuP3DLUKDoebQLc6nOw1d8ujJkf_TTmU4srGI">
  </iframe>
</section>

  );
};

export default BookSessionForm;
